/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-08 11:14:11
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 14:23:41
 */

import {
  IActivityInfo,
  IGetGamblingCountData,
} from "../../service/activity/interface";
import { IMedalInfo, IPostCreateTempDetail } from "../../service/Index";

/**
 * 设置 get_my_activity 接口数据
 */
export const SET_ACTIVITY_INFO_ACTION = "ACTIVITY.SET_ACTIVITY_INFO";
export const setActivityInfoAction = (data: IActivityInfo) => {
  return {
    type: SET_ACTIVITY_INFO_ACTION,
    data,
  };
};
export const SET_ACTIVITY_INFO_LOADING_ACTION = "ACTIVITY.SET_ACTIVITY_INFO_LOADING_ACTION";
export const setActivityInfoLoadingAction = (data: boolean) => {
  return {
    type: SET_ACTIVITY_INFO_LOADING_ACTION,
    data,
  };
};

/**
 * 设置 get_gambling_info接口，对赌奖金信息
 */
export const SET_GAMBLING_COUNT_ACTION = "ACTIVITY.SET_GAMBLING_COUNT";
export const setGamblingInfoAction = (data: IGetGamblingCountData) => {
  return {
    type: SET_GAMBLING_COUNT_ACTION,
    data,
  };
};

/**
 * 设置 activity_template 接口，模板信息
 */
export const SET_TEMP_DETAIL_ACTION = "ACTIVITY.SET_TEMP_DETAIL_ACTION";
export const setTempDetailAction = (data: IPostCreateTempDetail) => {
  return {
    type: SET_TEMP_DETAIL_ACTION,
    data,
  };
};
export const SET_MEDALS_ACTION = "ACTIVITY.SET_MEDALS_ACTION";
export const setMedalsAction = (data: IMedalInfo[]) => {
  return {
    type: SET_MEDALS_ACTION,
    data,
  };
};
